import { useContext } from "react"
import { auth } from "../../context/auth";
import { useTranslation } from 'react-i18next';


export default function System () {
    const { user } = useContext(auth);
    const { t } = useTranslation();
    return (
        <div className="system-config">
            <h4>{t("label:settings.branch.title")}</h4>
            <div className="parent flex">
                <div className="child">
                    <label>{t("label:settings.branch.body.id")}</label>
                    <input readOnly className="disabled-bg disabled" type="text" value={user.work.store} placeholder="branch number" />
                </div>
                <div className="child">
                    <label>{t("label:settings.branch.body.name")}</label>
                    <input readOnly className="disabled-bg disabled" type="text" value={user.work.workName} placeholder="work name" />
                </div>
            </div>
        </div>
    )
}